import React from "react";

import brand from "@utils/brand";
import { LevelCardSmall, LevelCardLarge, HeadingWIcon } from "@molecules";
import { Container } from "@atoms";

const MembershipLevels = ({ heading, copy, cards }) => {
  const { romero } = brand;
  return (
    <div className="py-12 md:pt-24">
      <Container>
        <HeadingWIcon
          icon="turtle"
          heading={heading}
          copy={copy}
          colors={romero ? { heading: "text-blue" } : null}
        />
        <div className="-mx-2 my-8 flex flex-wrap">
          {cards?.map(card => {
            if (card.type === "swatch") {
              return (
                <div className="my-8 w-full px-2">
                  <LevelCardLarge {...card} />
                </div>
              );
            }
            return (
              <div className="my-4 w-full px-2 sm:w-1/3">
                <LevelCardSmall {...card} />
              </div>
            );
          })}
        </div>
      </Container>
    </div>
  );
};

MembershipLevels.defaultProps = {};

export default MembershipLevels;
